import { Box, Typography } from "@mui/material";
import React from "react";

/**
 * CustomGroupHeader component renders a header with custom styling for a group.
 *
 * @param {Object} props.node
 * @param {string} props.node.value
 * @param {Object} [props.style={}] - Optional custom styles to be applied to the Typography component.
 *
 */
export default function CustomGroupHeader({ node, style = {}, empty = false }) {
  const { value } = node;

  return (
    <Box sx={{ ml: 1 }}>
      <Typography
        variant="body1"
        sx={{
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          mt: 0.5,
          ...style,
        }}
      >
        {empty ? "" : value}
      </Typography>
    </Box>
  );
}
